
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/windsurfer/login",
      function () {
        return require("private-next-pages/games/windsurfer/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/windsurfer/login"])
      });
    }
  